
const baseURL = '/ar';

export const getUserData = async () => {
  const url = baseURL+'/api/individuals/get-user-data/'
  const response = await fetch(url)
  if(!response.ok){
    throw new Error('user detail api failed')
  }
  return await response.json()
}